const newListEnabled_MapModel = () => {
    return {
        title: '',
        confirmLabelButton: 'Xác nhận',
        onClose: null,
        onSubmit: null,
        submitArgs: [],
        modalContent: '',
    }
}

const newList_NavigateModel = () => {
    return {
        csList: [],
        csList_Code: null,
        csList_Title: '',
    }
}

export const tableInteractiveModel = {
    newListEnabled_MapModel,
    newList_NavigateModel,
}
